
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import {useAppSelector} from '@/store/hooks.js';

// Définition de la requête GraphQL pour obtenir tous les rôles
const GET_ALL_ROLES = gql`
  query ALL_ROLES{
    allRoles{
      eligibleToProspectMigration
      name
    }
  }
`;

const useAllRoles = () => {
    // const user = useAppSelector((state) => state.auth.currentUser);
//   const companyUuid = user.company.uuid;

  const { loading, error, data, refetch } = useQuery(GET_ALL_ROLES, {
    // variables: { companyUuid },
    fetchPolicy: "network-only",
  });

  return {
    loading,
    error,
    allRoles: data?.allRoles,
    refetch
  };
};

export default useAllRoles;
